import { render, staticRenderFns } from "./AssetsFieldtype.vue?vue&type=template&id=421c294e&"
import script from "./AssetsFieldtype.vue?vue&type=script&lang=js&"
export * from "./AssetsFieldtype.vue?vue&type=script&lang=js&"
import style0 from "./AssetsFieldtype.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports